import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/account';
import { performGlobalLogout } from './authSlice';

export const getBankAccounts = createAsyncThunk(
    'account/getBankAccounts',
    async (amount, { rejectWithValue }) => {
        try {
            const response = await api.get(`/user/deposit/accounts?amount=${amount}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { message: 'Failed to listing' });
        }
    }
);

export const postDepositRequest = createAsyncThunk(
    'account/postDepositRequest',
    async (payload, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            
         
            formData.append('data', JSON.stringify({
                accountId: payload.accountId,
                amount: payload.amount,
                utrNumber: payload.utrNumber,
            }));
            
        
            if (payload.proofFile) {
                formData.append('proof', payload.proofFile);
            }

            const response = await api.post(`/user/deposit/request-with-proof`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || { message: 'Failed to submit deposit request' }
            );
        }
    }
);


// export const postOcr = createAsyncThunk(
//   'account/postOcr',
//   async (formData, { rejectWithValue }) => {
//     try {
//       const response = await api.post(
//         '/user/deposit/extract-utr',
//         formData,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       return response.data;
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data || {
//           message: 'Failed to submit deposit request',
//         }
//       );
//     }
//   }
// );

export const getDepositeHistroy = createAsyncThunk(
    'account/getDepositeHistroy',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`/user/deposit/history`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { message: 'Failed to listing' });
        }
    }
);


export const postwithdrawRequest = createAsyncThunk(
    'account/postwithdrawRequest',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.post(`user/withdraw/request`, payload);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || { message: 'Failed to submit deposit request' }
            );
        }
    }
);


export const getwithdrawHistroy = createAsyncThunk(
    'account/getwithdrawHistroy',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`user/withdraw/history`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { message: 'Failed to listing' });
        }
    }
);


export const postbankdetails = createAsyncThunk(
    'account/postbankdetails',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.post(`user/bank-accounts`, payload);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || { message: 'Failed to submit deposit request' }
            );
        }
    }
);

export const getwithdrawbankdetails = createAsyncThunk(
    'account/getwithdrawbankdetails',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`user/bank-accounts`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { message: 'Failed to listing' });
        }
    }
);



export const Deletebankdetails = createAsyncThunk(
    'account/Deletebankdetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`user/bank-accounts/${id}`); 
            return { id, ...response.data };
        } catch (err) {
            return rejectWithValue(err.response?.data || { message: 'Failed to delete' });
        }
    }
);

export const postwithdrawsecuirty = createAsyncThunk(
    'account/postwithdrawsecuirty',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.post(`/user/transaction-security/verify-tpin`, payload);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || { message: 'Failed to submit deposit request' }
            );
        }
    }
);

export const postSetWithdrawSecurity = createAsyncThunk(
    'account/postSetWithdrawSecurity',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.post(`/user/transaction-security/set-tpin`, payload);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || { message: 'Failed to set transaction password' }
            );
        }
    }
);

export const getWithdrawSecurityStatus = createAsyncThunk(
    'account/getWithdrawSecurityStatus',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`/user/transaction-security/status`);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || { message: 'Failed to get security status' }
            );
        }
    }
);

export const resetWithdrawSecurity = createAsyncThunk(
    'account/resetWithdrawSecurity',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.post(`/user/transaction-security/reset-tpin`, payload);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || { message: 'Failed to reset transaction password' }
            );
        }
    }
);


const AccountSlice = createSlice({
    name: 'account',
    initialState: {
        data: [],
        BankAccounts: [],
        postDepositRequest:{},
        DepositeHistroy:[],
        withdrawHistroy:[],
        bankdetails:[],
        deletebankdetails:{},
        postbankdetails:{},
        withdrawRequest:{},
        postwithdrawsecuirty:{},
        postSetWithdrawSecurity: {},
        resetWithdrawSecurity: {},
        loading: false,
        error: null,
        withdrawSecurityStatus: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBankAccounts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBankAccounts.fulfilled, (state, action) => {
                state.loading = false;
                state.BankAccounts = action.payload;
            })
            .addCase(getBankAccounts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })



             .addCase(postDepositRequest.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postDepositRequest.fulfilled, (state, action) => {
                state.loading = false;
                state.postDepositRequest = action.payload;
            })
            .addCase(postDepositRequest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })

            .addCase(getDepositeHistroy.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getDepositeHistroy.fulfilled, (state, action) => {
                state.loading = false;
                state.DepositeHistroy = action.payload;
            })
            .addCase(getDepositeHistroy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })

             .addCase(postwithdrawRequest.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postwithdrawRequest.fulfilled, (state, action) => {
                state.loading = false;
                state.withdrawRequest = action.payload;
            })
            .addCase(postwithdrawRequest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })

            .addCase(getwithdrawHistroy.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getwithdrawHistroy.fulfilled, (state, action) => {
                state.loading = false;
                state.withdrawHistroy = action.payload;
            })
            .addCase(getwithdrawHistroy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })

            .addCase(postbankdetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postbankdetails.fulfilled, (state, action) => {
                state.loading = false;
                state.postbankdetails = action.payload;
            })
            .addCase(postbankdetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })


            .addCase(getwithdrawbankdetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getwithdrawbankdetails.fulfilled, (state, action) => {
                state.loading = false;
                state.bankdetails = action.payload;
            })
            .addCase(getwithdrawbankdetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })

            .addCase(Deletebankdetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(Deletebankdetails.fulfilled, (state, action) => {
                state.loading = false;
                state.deletebankdetails = action.payload;
            })
            .addCase(Deletebankdetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })

            .addCase(postwithdrawsecuirty.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postwithdrawsecuirty.fulfilled, (state, action) => {
                state.loading = false;
                state.postwithdrawsecuirty = action.payload;
            })
            .addCase(postwithdrawsecuirty.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })

            .addCase(postSetWithdrawSecurity.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postSetWithdrawSecurity.fulfilled, (state, action) => {
                state.loading = false;
                state.postSetWithdrawSecurity = action.payload;
            })
            .addCase(postSetWithdrawSecurity.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })




//             .addCase(postOcr.pending, (state) => {
//     state.loading = true;
//     state.error = null;
// })
// .addCase(postOcr.fulfilled, (state, action) => {
//     state.loading = false;
//     state.postOcr = action.payload;
// })
// .addCase(postOcr.rejected, (state, action) => {
//     state.loading = false;
//     state.error = action.payload?.message || 'Something went wrong';
// })

            .addCase(getWithdrawSecurityStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getWithdrawSecurityStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.withdrawSecurityStatus = action.payload;
            })
            .addCase(getWithdrawSecurityStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })

            .addCase(resetWithdrawSecurity.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(resetWithdrawSecurity.fulfilled, (state, action) => {
                state.loading = false;
                state.resetWithdrawSecurity = action.payload;
            })
            .addCase(resetWithdrawSecurity.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Something went wrong';
            })

            // GLOBAL LOGOUT
            .addCase(performGlobalLogout.fulfilled, (state) => {
                state.data = [];
                state.BankAccounts = [];
                state.postDepositRequest = {};
                state.DepositeHistroy = [];
                state.withdrawHistroy = [];
                state.bankdetails = [];
                state.deletebankdetails = {};
                state.postbankdetails = {};
                state.withdrawRequest = {};
                state.postwithdrawsecuirty = {};
                state.postSetWithdrawSecurity = {};
                state.resetWithdrawSecurity = {};
                state.loading = false;
                state.error = null;
                state.withdrawSecurityStatus = null;
            });

    },
});

export default AccountSlice.reducer;